import { Flow } from '../../../types/flow.types';
import { FlowsListFilter } from './flows-ui.reducer';

export const FLOWS_UI_ACTION_NAMES = {
  START_NEW_FLOW: 'FLOWS_UI_ACTION_NAMES.START_NEW_FLOW',
  CANCEL_NEW_FLOW: 'FLOWS_UI_ACTION_NAMES.CANCEL_NEW_FLOW',
  SET_FLOWS_FILTER: 'FLOWS_UI_ACTION_NAMES.SET_FLOWS_FILTER',
  SELECT_FLOW: 'FLOWS_UI_ACTION_NAMES.SELECT_FLOW',
  HIDE_VERSION_DETAILS: 'FLOWS_UI_ACTION_NAMES.HIDE_VERSION_DETAILS',
  SELECT_FLOW_VERSION: 'FLOWS_UI_ACTION_NAMES.SELECT_FLOW_VERSION',
  SELECT_FLOW_AND_VERSION: 'FLOWS_UI_ACTION_NAMES.SELECT_FLOW_AND_VERSION',
};

export const startNewFlow = () => ({
  type: FLOWS_UI_ACTION_NAMES.START_NEW_FLOW,
  payload: undefined,
});

export const cancelNewFlow = () => ({
  type: FLOWS_UI_ACTION_NAMES.CANCEL_NEW_FLOW,
  payload: undefined,
});

export const setFlowsFilter = (filter: FlowsListFilter) => ({
  type: FLOWS_UI_ACTION_NAMES.SET_FLOWS_FILTER,
  payload: filter,
});

export const selectFlow = (flowId: string) => ({
  type: FLOWS_UI_ACTION_NAMES.SELECT_FLOW,
  payload: flowId,
});

export const hideVersionDetails = () => ({
  type: FLOWS_UI_ACTION_NAMES.HIDE_VERSION_DETAILS,
  payload: undefined,
});

export const selectFlowVersion = (versionId: number) => ({
  type: FLOWS_UI_ACTION_NAMES.SELECT_FLOW_VERSION,
  payload: versionId,
});

export const selectFlowAndVersion = (flow: Flow) => ({
  type: FLOWS_UI_ACTION_NAMES.SELECT_FLOW_AND_VERSION,
  payload: {
    flowId: flow.id,
    versionRevision: (flow.activeRevision || flow.latestRevision).revision,
  },
});
